// sections/PaymentMethodSection/useDuitkuReady.ts — status gateway Duitku (idle).
import { useEffect, useState } from 'react';
import { fetchGatewayStatus } from '../../../../services/paymentGatewayStatus';

export function useDuitkuReady(brandId?: string): boolean | null {
    const [duitkuReady, setDuitkuReady] = useState<boolean | null>(null);

    useEffect(() => {
        let cancelled = false;
        setDuitkuReady(null);
        // Gateway idle ≤2s (submitGuards cek ulang saat submit — aman).
        const run = () => { fetchGatewayStatus(brandId).then(s => { if (!cancelled) setDuitkuReady(s.duitku); }).catch(() => { if (!cancelled) setDuitkuReady(false); }); };
        let t: ReturnType<typeof setTimeout>;
        if ('requestIdleCallback' in window) (window as any).requestIdleCallback(run, { timeout: 2000 }); else t = setTimeout(run, 800);
        return () => { cancelled = true; clearTimeout(t); };
    }, [brandId]);

    return duitkuReady;
}
